import { AppThunk } from '../../../store/rootReducer';
import * as rulerActions from '../actions/ruler.actions';
import {
  maxTimestampSelector,
  minTimestampSelector,
  timestampSelector,
} from '../../navigation/selectors/navigation.selectors';
import { clamp } from 'lodash';
import {
  rulerRangeSelector,
  rulerUpdateModeSelector,
} from '../selectors/ruler.selectors';

// The initial length of the ruler is going to be 600ms
const HALF_INITIAL_RULER = 300; // ms

export const initializeRuler = (): AppThunk => async (dispatch, getState) => {
  const [rulerStart, rulerEnd] = rulerRangeSelector(getState());
  const updateMode = rulerUpdateModeSelector(getState());
  const timestamp = timestampSelector(getState());
  const min = minTimestampSelector(getState());
  const max = maxTimestampSelector(getState());
  if (updateMode != null || rulerStart !== 0 || rulerEnd !== 0) {
    return;
  }
  const center = clamp(timestamp, min, max);
  const newStart = center - HALF_INITIAL_RULER;
  const newEnd = center + HALF_INITIAL_RULER;

  dispatch(
    rulerActions.setRange({
      start: newStart,
      end: newEnd,
      meta: { history: false },
    }),
  );
};
